<template>
  <div id="app">
    <router-view />
    <support-contact floating />
  </div>
</template>

<script>
import SupportContact from './components/SupportContact.vue';

export default {
  name: 'App',
  components: { SupportContact }
};
</script>
